import React from 'react';
import {
  Box,
  Column,
  Copy,
  Heading,
  Image,
  Link,
  Row,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { GroceriesOrderNowLinkButton } from 'src/components/enterprise/features/Groceries/components/GroceriesHero/GroceriesOrderNowLinkButton';
import { GroceriesHeroDisclaimer } from 'src/components/enterprise/features/Groceries/components/GroceriesHero/GroceriesHeroDisclaimer';
import { getGroceriesHeroImageUrl } from 'src/components/enterprise/features/Groceries/constants/groceriesAssets';
import { GroceriesContent } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

interface GroceriesHeroProps {
  groceriesContent: GroceriesContent;
  brandDisplayName: string;
  orderNowUrl: string;
}

export function GroceriesHero({
  groceriesContent,
  brandDisplayName,
  orderNowUrl,
}: GroceriesHeroProps): JSX.Element {
  const { isDesktop } = useScreenSizes();

  return (
    <Square bg="untintedBackground" borderRadius="medium" overflow="hidden">
      <Row alignItems="center">
        <Column phone={12} tablet={12} desktop={6}>
          <Box p="12">
            <Stack y="x-sm">
              <Heading variant="xxlarge">{groceriesContent.hero.title}</Heading>
            </Stack>
            <Stack y="lg">
              <Copy variant="body">{groceriesContent.hero.subtitle}</Copy>
            </Stack>
            <Stack y="x-sm">
              <Link href={orderNowUrl} as={GroceriesOrderNowLinkButton}>
                {groceriesContent.hero.cta.label}
              </Link>
            </Stack>
            <Stack>
              <GroceriesHeroDisclaimer
                brandDisplayName={brandDisplayName}
                legalLinks={groceriesContent.hero.legalLinks}
              />
            </Stack>
          </Box>
        </Column>
        <Column phone={12} tablet={12} desktop={6}>
          <Image
            src={getGroceriesHeroImageUrl(isDesktop)}
            alt=""
            role="presentation"
          />
        </Column>
      </Row>
    </Square>
  );
}
